module.exports = __webpack_public_path__ + "static/media/test14.1b016cae.jpeg";